import { NgModule } from '@angular/core';
import { DemoPageComponent } from './containers/demo-page/demo-page';
import { SampleBannerComponent } from './containers/sample-banner/sample-banner';
import { MatButtonModule, MatIconModule, MatSidenavModule, MatToolbarModule } from '@angular/material';
import { GridPageComponent } from './containers/grid-page/grid-page';
import { AgGridModule } from 'ag-grid-angular';
import { DbPageComponent } from './containers/db-page/db-page';
import { WidgetService } from './services/widget.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SampleRoutingModule } from './sample-routing.module';
import { SampleLayoutComponent } from './containers/sample-layout/sample-layout';
import { WelcomePageComponent } from './containers/welcome-page/welcome-page';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SampleRoutingModule,

    // ag-grid
    // AgGridModule.withComponents([...optional Angular Components to be used in the grid....]),
    AgGridModule.withComponents([]),


    // @angular/material
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatSidenavModule,

  ],
  exports: [],
  declarations: [
    SampleLayoutComponent,
    WelcomePageComponent,
    DemoPageComponent,
    SampleBannerComponent,
    GridPageComponent,
    DbPageComponent,
  ],
  providers: [
    WidgetService,
  ],
})
export class SampleModule {}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/sample.module.ts